export const buildAccessChecker = (userApplications) => {
    const set = new Set(userApplications || []);
    return (appName) => !appName || set.has(appName);
};
